// extracted by mini-css-extract-plugin
export default {"sideMenuBody":"appLayout_sideMenuBody__-8u2m","buttons":"appLayout_buttons__ymTSy","appBar":"appLayout_appBar__hlg2W","logout":"appLayout_logout__T-nMp"};